"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
// Borrowed from https://github.com/johndiiorio/react-useinterval
function useInterval(callback, delay, ...args) {
    const savedCallback = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        savedCallback.current = callback;
    }, [callback]);
    (0, react_1.useEffect)(() => {
        function tick() {
            if (savedCallback.current !== undefined) {
                savedCallback.current(...args);
            }
        }
        if (delay !== null && delay !== undefined) {
            const id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
        return undefined;
    }, [delay]);
}
exports.default = useInterval;
//# sourceMappingURL=interval.js.map